var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"center-layout"},[_c('p',{staticClass:"description"},[_vm._v("大変申し訳ありませんが、該当ページがございません。")]),_c('BtnBase',{attrs:{"label":"戻る","addClass":"btn-previous"},on:{"onClick":_vm.back}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }